<div class="payment-ticket">
    <h2 class="align-center pb-4">
        {{ 'CART_TICKETS_TITLE' | translate }}
    </h2>
    <div [ngClass]="{ 'block--wrap-secondary block': isVoucher }">
        <div class="voucher" *ngIf="isVoucher">
            <div class="voucher__top-content">
                <div class="voucher-left-content">
                    <div class="voucher-left-content__items">
                        <span class="title">{{ 'TICKET_SUMMARY_V2_TICKET_TYPE' | translate }}</span>
                        <span class="description">{{ 'VOUCHER' | translate }}</span>
                    </div>

                    <div class="voucher-left-content__items">
                        <span class="title">
                            {{ 'TICKET_SUMMARY_V2_TRAVELLER_EMAIL' | translate }}
                        </span>
                        <span class="description">{{ voucherEmail }}</span>
                    </div>
                </div>
                <div class="voucher-right-content">
                    <div class="voucher-left-content__items full-width">
                        <span class="title">{{ 'TICKET_SUMMARY_V2_PRICE' | translate }}</span>
                        <span class="description">
                            {{ (cart$ | async).voucherTicket.price | moneyFormat }}
                            {{ appStartupService.getCurrency() | translate }}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="item-title" *ngIf="isVoucher">
            {{ 'TICKETS_ON_VOUCHER' | translate }}
        </div>

        <ng-container *ngIf="!env.IS_CORPORATE">
            <div class="checkout-block checkout-page__goods-block" *ngFor="let dn of allDocNums$ | async">
                <section attr.aria-label="{{ 'TICKET_GROUP_INFO_ARIA_LABEL' | translate }}">
                    <ridango-ticket
                        [ticket]="(cart$ | async).ticketsByDocNum[dn]"
                        [actions]="ticketActions"
                        [useInputActions]="useInputActions"
                        [locale]="locale"
                        [transportDayEndPrevDate]="transportDayEndPrevDate"
                        [productType]="getProductTypeByDocNum(dn)"
                        [hasZoneModal]="env.TICKET_HAS_ZONE_MODAL"
                        [assetsPath]="assetsPath$ | async"
                        (requestTicketAction)="ticketAction($event)">
                    </ridango-ticket>
                </section>
            </div>
        </ng-container>
        <ng-container *ngIf="env.IS_CORPORATE">
            <div
                class="checkout-block checkout-page__goods-block"
                *ngFor="let groupedTicket of groupedTicketsByProduct$ | async">
                <section attr.aria-label="{{ 'TICKET_GROUP_INFO_ARIA_LABEL' | translate }}">
                    <ridango-ticket
                        [ticket]="groupedTicket"
                        [actions]="ticketActions"
                        [useInputActions]="useInputActions"
                        [locale]="locale"
                        [transportDayEndPrevDate]="transportDayEndPrevDate"
                        [productType]="getProductTypeByDocNum(groupedTicket.docNums[0])"
                        [hasZoneModal]="env.TICKET_HAS_ZONE_MODAL"
                        [ticketsByDocNums]="(cart$ | async).ticketsByDocNum"
                        [canDeleteFromCart]="(cart$ | async).status !== 'L'"
                        [assetsPath]="assetsPath$ | async"
                        (requestTicketAction)="ticketAction($event)"
                        (requestRemoveCard)="removeCard($event)">
                    </ridango-ticket>
                </section>
            </div>
        </ng-container>
    </div>
    <div class="payment-ticket__another-ticket" *ngIf="(cart$ | async).status !== 'L' && !env.ENABLE_PURCHASE_V2">
        <button class="btn btn--secondary" [routerLink]="'/purchase/ticket' | localize">
            {{ 'SHOPPING_CART_ADD_ANOTHER_TICKET' | translate }}
        </button>
    </div>
</div>
